import { useEffect } from 'react';
import { Accordion } from '@iwoca/orion';
import { Trans } from '@lingui/macro';
import { useFileUploadReducer } from 'components/Signup/hooks/useFileUploadReducer';
import {
  useGetDocuments,
  useGetIntroducerApplication,
} from 'lendingApi/lendingApiHooks';
import styles from '../DocumentGroup/DocumentGroup.module.css';
import { FILE_STATUS_GROUPS } from '../DocumentGroup/DocumentGroupHelper';
import { FileStatusGroup } from '../FileStatusGroup/FileStatusGroup';
import { UploadDropButton } from '../UploadDropButton/UploadDropButton';

type TProps = {
  isPartnerChannel: boolean;
};

export const OtherDocumentGroup = ({ isPartnerChannel }: TProps) => {
  const { application } = useGetIntroducerApplication();

  const {
    uploadedFiles,
    setAllFiles,
    setFileLoading,
    setFileSuccess,
    setFileError,
    setFileReject,
    removeFile,
  } = useFileUploadReducer();

  const stateKey = application?.customer?.state_key;
  const { data: documents } = useGetDocuments(stateKey);

  useEffect(() => {
    if (documents) {
      const otherDocuments = documents?.data?.filter((uploadedDocument) => {
        return 'other' === uploadedDocument.type;
      });

      setAllFiles(otherDocuments);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documents]);

  if ((isPartnerChannel && uploadedFiles.length === 0) || !stateKey) {
    return null;
  }

  return (
    <Accordion
      className={styles.accordion}
      titleClassName={styles.titleContainer}
      title={
        <p className={styles.title}>
          <Trans>Other documents</Trans>
          <span className={styles.optional}> (Optional)</span>
        </p>
      }
    >
      <>
        {!isPartnerChannel && (
          <UploadDropButton
            setFileLoading={setFileLoading}
            setFileSuccess={setFileSuccess}
            setFileError={setFileError}
            setFileReject={setFileReject}
            stateKey={stateKey}
            documentType="other"
          />
        )}
        {FILE_STATUS_GROUPS.map((statusGroup) => {
          return (
            <FileStatusGroup
              key={`other-${statusGroup}`}
              testId={statusGroup}
              statusGroup={statusGroup}
              files={uploadedFiles}
              removeFile={removeFile}
            />
          );
        })}
      </>
    </Accordion>
  );
};
